export const GET_ACTIVITY_LOGS_REQUEST = "GET_ACTIVITY_LOGS_REQUEST";
export const GET_ACTIVITY_LOGS_RESPONSE = "GET_ACTIVITY_LOGS_RESPONSE";
export const GET_ACTIVITY_LOGS_FAILURE = "GET_ACTIVITY_LOGS_FAILURE";
